// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1m-o";
export var animationRelative = "_1m-n";
export var backdropBlur = "_1m-0";
export var detailLabelCell = "_1m-10";
export var detailTable = "_1m-z";
export var detailValueCell = "_1m-11";
export var docIconBox = "_1m-19";
export var docTypeRow = "_1m-14";
export var docTypeRowInner = "_1m-15";
export var dropdownMatchDatePicker = "_1m-1";
export var fileUploadSpin = "_1m-h";
export var gorgiasOpenButton = "_1m-13 _1m-b";
export var gorgiasTicketCard = "_1m-12";
export var heroModalFooterButton = "_1m-16";
export var hiddenContainer = "_1m-m";
export var maxWidthContainer = "_1m-17";
export var modalContentBody = "_1m-8";
export var modalHeaderImage = "_1m-3";
export var modalImageLabel = "_1m-5";
export var modalImageOverlay = "_1m-4";
export var modalImageSubtitle = "_1m-7";
export var modalImageTitle = "_1m-6";
export var modalImageWrapper = "_1m-2";
export var modalStickyFooter = "_1m-9";
export var removeButton = "_1m-c";
export var sidebarColumn = "_1m-18";
export var spinner = "_1m-g";
export var timelineLine = "_1m-w";
export var timelineLineBlack = "_1m-y _1m-w";
export var timelineLineGray = "_1m-x _1m-w";
export var timelineLineHeight = "_1m-v";
export var tlDotActivate = "_1m-s";
export var tlDotActivateAnim = "_1m-r";
export var tlDotHide = "_1m-q";
export var tlDotHideAnim = "_1m-p";
export var tlLineActivate = "_1m-u";
export var tlLineActivateAnim = "_1m-t";
export var uploadHint = "_1m-l";
export var uploadIconBox = "_1m-i";
export var uploadLabel = "_1m-k";
export var uploadText = "_1m-j";
export var uploadZone = "_1m-d";
export var uploadZoneCursorDefault = "_1m-f";
export var uploadZoneCursorPointer = "_1m-e";
export var uploadedFileRow = "_1m-a";
export var viewButton = "_1m-b";